import React, { Component } from 'react';
import { Modal, Input, Form, InputNumber, Select } from 'antd';
import { Unit } from '../../../../components/Label';

export default class ItemForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: this.props.visible
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.visible !== this.state.visible) {
            this.setState({ visible: nextProps.visible });
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.onSubmit({
                    id: this.props.item ? this.props.item.id : null,
                    title: values.title,
                    qty: values.qty,
                    unit: values.unit
                });
                this.props.form.resetFields(['title', 'qty', 'unit']);
            }
        });
    }

    handleCancel = () => {
        this.setState({ visible: false });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { visible } = this.state;
        const { loading, list, item } = this.props;

        const formItemLayout = {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 3 },
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 21 },
            },
        };

        return (
            <Modal
                title={`Lägg till i: ${list.title}`}
                visible={visible}
                okText={item ? 'Spara' : 'Lägg till'}
                cancelText="Avbryt"
                confirmLoading={loading}
                onOk={this.handleSubmit}
                onCancel={this.handleCancel}
            >
                <Form  layout="horizontal" onSubmit={this.handleSubmit}>
                    <Form.Item label="Titel" {...formItemLayout}>
                        {getFieldDecorator('title', {
                            validateTrigger: ['onChange', 'onBlur'],
                            rules: [{ required: true, message: 'Titel saknas!' }],
                            initialValue: item ? item.title : ''
                        })(
                            <Input placeholder="Titel" size="large" name="title" />
                        )}
                    </Form.Item>
                    <Form.Item label="Antal" {...formItemLayout}>
                        {getFieldDecorator('qty', {
                            initialValue: item ? item.ingredient.qty : 1
                        })(
                            <InputNumber placeholder="Antal" size="large" name="qty" />
                        )}
                    </Form.Item>
                    <Form.Item label="Enhet" {...formItemLayout}>
                        {getFieldDecorator('unit', {
                            initialValue: item ? item.ingredient.unit : 'PC'
                        })(
                            <Select>
                                <Select.Option value="PC"><Unit type="PC" /></Select.Option>
                                <Select.Option value="G"><Unit type="G" /></Select.Option>
                                <Select.Option value="KG"><Unit type="KG" /></Select.Option>
                                <Select.Option value="ML"><Unit type="ML" /></Select.Option>
                                <Select.Option value="TSP"><Unit type="TSP" /></Select.Option>
                                <Select.Option value="DL"><Unit type="DL" /></Select.Option>
                                <Select.Option value="TBSP"><Unit type="TBSP" /></Select.Option>
                                <Select.Option value="L"><Unit type="L" /></Select.Option>    
                            </Select>
                        )}
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/screens/dashboard/components/grocery-list/ItemForm.js